export default __webpack_public_path__ + "static/OProductLineFull-e0b4ca3cab656a7dce706f503e7e6fbf.mp4";